import { GenericInlineItemListTranslations } from './generic-inline-item-list-translations.interface';

export const GERMAN_GENERIC_INLINE_ITEM_LIST_TRANSLATIONS: GenericInlineItemListTranslations = {
  labels: {
    groupLabel: 'Elementliste',
    emptyList: 'Keine Elemente vorhanden.',
    itemEntry: 'Element {index} von {total}',
  },
  buttons: {
    appendItem: 'Element hinzufügen',
    appendItemLabel: 'Element hinzufügen',
    removeItem: 'Element {index} entfernen',
  },
};
